import {
    ENTREGACERTA_DETALHES_NF,
    ENTREGACERTA_DETALHES_NF_LOADING,
    ENTREGACERTA_SCREEN,
    ENTREGACERTA_SAVE_LOADING,
    ENTREGACERTA_RESTRICAO_LOADING,
    ENTREGACERTA_RESTRICAO
} from '../actions/ActionsTypes';

const INITIAL_STATE = {
    dadosNF: [],
    isLoadingBody: true,
    screen: 0,
    isLeadingSave: false,
    entregaCertaRestricao: [],
    entregaCertaRestricaoLoading: false,
}


// eslint-disable-next-line
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case ENTREGACERTA_DETALHES_NF:
            return { ...state, dadosNF: action.payload }

        case ENTREGACERTA_DETALHES_NF_LOADING:
            return { ...state, isLoadingBody: action.payload }

        case ENTREGACERTA_SCREEN:
            return { ...state, screen: action.payload }

        case ENTREGACERTA_SAVE_LOADING:
            return { ...state, isLeadingSave: action.payload }

        case ENTREGACERTA_RESTRICAO:
            return { ...state, entregaCertaRestricao: action.payload }

        case ENTREGACERTA_RESTRICAO_LOADING:
            return { ...state, entregaCertaRestricaoLoading: action.payload }

        default:
            return state;
    }
}